var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_2692_13058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.86 14.86C13.4614 15.9261 11.7584 16.5167 10 16.5455C4.27273 16.5455 1 10 1 10C2.01773 8.1034 3.42929 6.44635 5.14 5.14003M8.28182 3.65094C8.845 3.51912 9.4216 3.45322 10 3.45458C15.7273 3.45458 19 10 19 10C18.5033 10.9292 17.911 11.8039 17.2327 12.61M11.7345 11.7346C11.5098 11.9757 11.2389 12.1692 10.9378 12.3033C10.6367 12.4375 10.3116 12.5096 9.98207 12.5154C9.6525 12.5212 9.32513 12.4606 9.0195 12.3372C8.71386 12.2137 8.43623 12.03 8.20315 11.7969C7.97007 11.5638 7.78632 11.2862 7.66287 10.9805C7.53942 10.6749 7.47879 10.3475 7.48461 10.018C7.49042 9.68839 7.56256 9.36336 7.69672 9.06227C7.83087 8.76118 8.0243 8.4902 8.26545 8.26549",
    stroke: "#848B9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 1L19 19",
    stroke: "#848B9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2692_13058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.6c06461fa5d48640601b5e5db84df315.svg";
export { ForwardRef as ReactComponent };